module.exports = __webpack_public_path__ + "static/media/csk-tablet-738x57-80.b4724a8c.webp";